module.exports = __webpack_public_path__ + "media/images/app/top-837373f6208dd77e9ef2912ee216de3d.svg";